import { useTranslation } from 'react-i18next';

import { type PageSizeValues, Pagination, Table } from '@wf/components';

import { DEFAULT_PAGE_SIZE } from '../../constants';

import styles from './TableFooter.module.scss';

interface ITableFooter {
  page: number;
  totalCount: number;
  handlePageChange?: (page: number) => void;
  pageSize?: number;
  withPagination?: boolean;
}

function TableFooter({
  page,
  totalCount,
  handlePageChange = () => null,
  pageSize = DEFAULT_PAGE_SIZE,
  withPagination = true,
}: ITableFooter) {
  const { t } = useTranslation();

  return (
    <Table.Footer>
      <div className={styles.tableFooter}>
        <span className={styles.totalNumber}>
          {t('Total number of records')}: <span className={styles.totalCount}>{totalCount}</span>
        </span>

        {withPagination && totalCount > pageSize && (
          <Pagination
            defaultPageSize={pageSize as PageSizeValues}
            onPageChange={handlePageChange}
            totalItems={totalCount}
            page={page}
            t={t}
          />
        )}
      </div>
    </Table.Footer>
  );
}

export default TableFooter;
